const favoriteQuestionOptions = [
    {value: "none", selection: "No Security Question Selected"},
    {value: "favBookMovie", selection: "What is your favorite book or movie?"},
    {value: "visitPlc", selection: "What is a city or place you'd love to visit?"},
    {value: "vidGame", selection: "What is your favorite video game?"},
    {value: "vacation", selection: "What is your dream vacation destination?"},
    {value: "cartChar", selection: "What is your favorite cartoon character?"},
    {value: "ughFood", selection: "What is your least favorite food?"},
    {value: "superPower", selection: "If you had a superpower, what would it be?"},
    {value: "petDragon", selection: "What name would you give a pet dragon?"},
    {value: "rockBand", selection: "What would be the name of your rock band?"},
    {value: "favClass", selection: "What is your favorite class subject?"}
]
export default favoriteQuestionOptions;